module.exports = "/_next/static/images/loading_02-f5a586a0fe249533c5ce7c92d9a30208.png";